import { createSvgIcon } from "@mui/material";

export const StabilityIcon = createSvgIcon(
  <svg viewBox="0 0 40 40" fill="none">
    <g clipPath="url(#clip0_811_1958)">
      <path
        d="M14.5202 30.4458C19.3983 30.4458 22.571 27.8622 22.571 23.9756C22.571 20.9615 20.6413 19.0462 17.1909 18.2531L14.9757 17.5885C13.0324 17.1524 11.8981 16.6285 12.1653 15.2902C12.3876 14.1769 13.0528 13.5484 14.5995 13.5484C19.5165 13.5484 21.3383 15.2902 21.3383 15.2902V11.1008C21.3383 11.1008 19.5646 9.5 14.5995 9.5C9.91979 9.5 7.38037 11.908 7.38037 15.6359C7.38037 18.65 9.14023 20.4028 12.7094 21.2357C12.9593 21.2982 13.087 21.3303 13.0925 21.332C13.6354 21.5 14.368 21.722 15.2904 21.998C17.1147 22.4342 17.5838 22.8972 17.5838 24.2853C17.5838 25.5544 16.2652 26.2758 14.5202 26.2758C9.49339 26.2757 7.38037 23.7327 7.38037 23.7327V28.3742C7.38037 28.3742 8.7017 30.4456 14.5202 30.4456V30.4458Z"
        fill="currentColor"
      />
      <path
        d="M29.6071 30.1319C31.3339 30.1319 32.6198 28.8828 32.6198 27.1927C32.6198 25.4659 31.3707 24.2534 29.6071 24.2534C27.8803 24.2534 26.6311 25.4659 26.6311 27.1927C26.6311 28.9196 27.8803 30.1319 29.6071 30.1319Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_811_1958">
        <rect
          width="25.2394"
          height="21"
          fill="white"
          transform="translate(7.38037 9.5)"
        />
      </clipPath>
    </defs>
  </svg>,
  "StabilityIcon",
);
